/** Spinner shown while a lazy-loaded route chunk is being fetched. */
export function LazyFallback() {
  return (
    <div className="flex items-center justify-center p-10">
      <div className="animate-spin w-6 h-6 border-2 border-brand-600 border-t-transparent rounded-full" />
    </div>
  )
}
